import React from 'react';
import { Carousel } from 'antd';

// NOTE: 광고배너 이미지 파일을 src/assets 폴더에 넣고 import 해주세요.
import PcAdBanner01 from 'assets/adbanner_pc01_2026_1_22.png';
import MobileAdBanner01 from 'assets/adbanner_m01_2026_1_22.png';
import PcAdBanner02 from 'assets/adbanner_pc02_2026_1_22.png';
import MobileAdBanner02 from 'assets/adbanner_m02_2026_1_22.png';

const AdBanner = (props) => {
  /* ===== Route ===== */
  /* ===== Props ===== */
  const { type = 'pc' } = props;

  /* ===== State ===== */
  /* ===== Hooks ===== */
  /* ===== Function ===== */
  /* ===== Variable ===== */
  /* ===== Hooks ===== */
  /**
   * NOTE: 광고 배너 목록
   * --
   * @property {string} href - 클릭 시 이동할 url
   * @property {string} target - 새 창 열림 타입
   * @property {string} pc - PC 배너 경로
   * @property {string} mobile - 모바일 배너 경로
   * @property {string} alt - 이미지 alt 내용
   */
  const BannerItems = React.useMemo(() => {
    return [
      {
        href: 'https://www.youtube.com/watch?v=kWcWVXnY8lo',
        target: '_blank',
        pc: PcAdBanner01,
        mobile: MobileAdBanner01,
        alt: '광고배너',
      },
      {
        href: 'https://jmcoffee.co.kr/contact/inquire/',
        target: '_blank',
        pc: PcAdBanner02,
        mobile: MobileAdBanner02,
        alt: '광고배너',
      },
    ];
  }, []);

  /**
   * NOTE: 광고배너 슬라이드 설정
   * --
   * 슬라이드 설정 변경 시 아래의 내용 변경해주세요.
   * 변경 가능한 값은 [] 내부에 있습니다.
   * 형식에 맞추어 변경해주세요.
   */
  const BannerProps = React.useMemo(() => {
    return {
      effect: 'fade', // 스크롤 효과 ['scrollx' || 'fade']
      autoplay: true, // 자동 재생 여부 [true || false]
      autoplaySpeed: 5000, // 자동 재생 속도 (ms) - 예) 5000 -> 5초
      draggable: true, // 드래그 가능 여부 [true || false]
      dots: true, // 페이지네이션 여부 [true || false]
      dotPosition: 'bottom', // 페이지네이션 위치 ['top' || 'bottom' || 'left' || 'right']
    };
  }, []);

  /* ===== Render ===== */
  return (
    <Carousel {...BannerProps}>
      {BannerItems.map((item, index) => (
        <div key={`AD_Banner_${item.alt}_${index}`}>
          <a
            href={item.href}
            target={item.target ?? '_blank'}
            rel={'noreferrer'}
          >
            <img
              src={item[type]}
              alt={item.alt ?? `광고배너 ${index}`}
              width={'100%'}
              height={'auto'}

              // height={type !== 'pc' ? 'auto' : '30%'}
            />
          </a>
        </div>
      ))}
    </Carousel>
  );
};

export default AdBanner;
